import React from 'react';
import config from '../config';
import BackButton from './BackButton';

function DashboardPage({ setPage, handleLogout, user, savedSearches, userUsage, handleSearch }) {
  return (
      <div style={{ minHeight: '100vh', background: '#f5f7fa' }}>
        <header style={{ padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'white', borderBottom: '1px solid #e0e0e0' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <BackButton onClick={() => setPage('search')} />
            <img src="/logo.svg" alt="PatTrak Logo" style={{ height: '32px', cursor: 'pointer' }} onClick={() => setPage('search')} />
          </div>
          <button onClick={handleLogout} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#1d2934' }}>
            Logout
          </button>
        </header>

        <main style={{ maxWidth: '900px', margin: '32px auto', padding: '0 16px' }}>
          <h1 style={{ fontSize: '28px', fontWeight: 'bold', color: '#1d2934', marginBottom: '24px' }}>Dashboard</h1>

          {/* Account Section */}
          <div style={{ background: 'white', borderRadius: '8px', padding: '24px', marginBottom: '24px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#1d2934', marginBottom: '16px', borderBottom: '1px solid #e0e0e0', paddingBottom: '8px' }}>Account</h2>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              <div>
                <div style={{ color: '#5e778a', fontSize: '14px' }}>Name</div>
                <div style={{ color: '#1d2934', fontSize: '16px', fontWeight: '500' }}>{user.full_name || 'Not set'}</div>
              </div>
              <div>
                <div style={{ color: '#5e778a', fontSize: '14px' }}>Email</div>
                <div style={{ color: '#1d2934', fontSize: '16px', fontWeight: '500' }}>{user.email}</div>
              </div>
              <div>
                <div style={{ color: '#5e778a', fontSize: '14px' }}>Tier</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <span style={{ 
                    color: user.tier === 'pro' ? '#059669' : user.tier === 'premium' ? '#2563eb' : '#1d2934', 
                    fontSize: '16px', 
                    fontWeight: '600',
                    textTransform: 'capitalize'
                  }}>
                    {user.tier === 'free' ? 'Freemium' : user.tier}
                  </span>
                  {user.tier !== 'pro' && (
                    <button 
                      onClick={() => setPage('pricing')} 
                      style={{ 
                        background: '#53dafc', 
                        color: 'white', 
                        padding: '4px 12px', 
                        borderRadius: '4px', 
                        border: 'none', 
                        cursor: 'pointer',
                        fontSize: '13px'
                      }}
                    >
                      Upgrade to {user.tier === 'free' ? 'Premium' : 'Pro'}
                    </button>
                  )}
                </div>
              </div>
              <div>
                <div style={{ color: '#5e778a', fontSize: '14px' }}>Member Since</div>
                <div style={{ color: '#1d2934', fontSize: '16px', fontWeight: '500' }}>
                  {user.created_at ? new Date(user.created_at).toLocaleDateString('en-GB', { month: 'long', year: 'numeric' }) : 'Unknown'}
                </div>
              </div>
            </div>
          </div>

          {/* Today's Usage Section */}
          <div style={{ background: 'white', borderRadius: '8px', padding: '24px', marginBottom: '24px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#1d2934', marginBottom: '16px', borderBottom: '1px solid #e0e0e0', paddingBottom: '8px' }}>Today's Usage</h2>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              {/* AI Searches */}
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                  <span style={{ color: '#5e778a', fontSize: '14px' }}>AI Searches</span>
                  <span style={{ color: '#1d2934', fontSize: '14px' }}>
                    {userUsage?.ai_searches?.used || 0} / {userUsage?.ai_searches?.limit >= 9999 ? '∞' : userUsage?.ai_searches?.limit || 0}
                  </span>
                </div>
                <div style={{ background: '#e0e0e0', borderRadius: '4px', height: '8px' }}>
                  <div style={{ 
                    background: '#53dafc', 
                    borderRadius: '4px', 
                    height: '8px', 
                    width: `${Math.min(100, ((userUsage?.ai_searches?.used || 0) / Math.max(1, userUsage?.ai_searches?.limit || 1)) * 100)}%` 
                  }}></div>
                </div>
              </div>
              {/* Quick Analyses */}
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                  <span style={{ color: '#5e778a', fontSize: '14px' }}>Quick Analyses</span>
                  <span style={{ color: '#1d2934', fontSize: '14px' }}>
                    {userUsage?.quick_analyses?.used || 0} / {userUsage?.quick_analyses?.limit >= 999 ? '∞' : userUsage?.quick_analyses?.limit || 0}
                  </span>
                </div>
                <div style={{ background: '#e0e0e0', borderRadius: '4px', height: '8px' }}>
                  <div style={{ 
                    background: '#53dafc', 
                    borderRadius: '4px', 
                    height: '8px', 
                    width: `${Math.min(100, ((userUsage?.quick_analyses?.used || 0) / Math.max(1, userUsage?.quick_analyses?.limit || 1)) * 100)}%` 
                  }}></div>
                </div>
              </div>
              {/* Standard Analyses */}
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                  <span style={{ color: '#5e778a', fontSize: '14px' }}>Standard Analyses</span>
                  <span style={{ color: '#1d2934', fontSize: '14px' }}>
                    {userUsage?.standard_analyses?.used || 0} / {userUsage?.standard_analyses?.limit >= 999 ? '∞' : userUsage?.standard_analyses?.limit || 0}
                  </span>
                </div>
                <div style={{ background: '#e0e0e0', borderRadius: '4px', height: '8px' }}>
                  <div style={{ 
                    background: userUsage?.standard_analyses?.limit === 0 ? '#ccc' : '#53dafc', 
                    borderRadius: '4px', 
                    height: '8px', 
                    width: userUsage?.standard_analyses?.limit === 0 ? '0%' : `${Math.min(100, ((userUsage?.standard_analyses?.used || 0) / Math.max(1, userUsage?.standard_analyses?.limit || 1)) * 100)}%` 
                  }}></div>
                </div>
              </div>
              {/* Application Searches */}
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                  <span style={{ color: '#5e778a', fontSize: '14px' }}>Application Searches</span>
                  <span style={{ color: '#1d2934', fontSize: '14px' }}>
                    {userUsage?.app_searches?.used || 0} / {userUsage?.app_searches?.limit >= 9999 ? '∞' : userUsage?.app_searches?.limit || 0}
                  </span>
                </div>
                <div style={{ background: '#e0e0e0', borderRadius: '4px', height: '8px' }}>
                  <div style={{ 
                    background: '#53dafc', 
                    borderRadius: '4px', 
                    height: '8px', 
                    width: `${Math.min(100, ((userUsage?.app_searches?.used || 0) / Math.max(1, userUsage?.app_searches?.limit || 1)) * 100)}%` 
                  }}></div>
                </div>
              </div>
              {/* Company Intel */}
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                  <span style={{ color: '#5e778a', fontSize: '14px' }}>Company Intelligence</span>
                  <span style={{ color: '#1d2934', fontSize: '14px' }}>
                    {userUsage?.company_intel?.used || 0} / {userUsage?.company_intel?.limit >= 9999 ? '∞' : userUsage?.company_intel?.limit || 0}
                  </span>
                </div>
                <div style={{ background: '#e0e0e0', borderRadius: '4px', height: '8px' }}>
                  <div style={{ 
                    background: '#53dafc', 
                    borderRadius: '4px', 
                    height: '8px', 
                    width: `${Math.min(100, ((userUsage?.company_intel?.used || 0) / Math.max(1, userUsage?.company_intel?.limit || 1)) * 100)}%` 
                  }}></div>
                </div>
              </div>
              {/* Citations */}
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                  <span style={{ color: '#5e778a', fontSize: '14px' }}>Citation Analyses</span>
                  <span style={{ color: '#1d2934', fontSize: '14px' }}>
                    {userUsage?.citations?.used || 0} / {userUsage?.citations?.limit >= 9999 ? '∞' : userUsage?.citations?.limit || 0}
                  </span>
                </div>
                <div style={{ background: '#e0e0e0', borderRadius: '4px', height: '8px' }}>
                  <div style={{ 
                    background: userUsage?.citations?.limit === 0 ? '#ccc' : '#53dafc', 
                    borderRadius: '4px', 
                    height: '8px', 
                    width: userUsage?.citations?.limit === 0 ? '0%' : `${Math.min(100, ((userUsage?.citations?.used || 0) / Math.max(1, userUsage?.citations?.limit || 1)) * 100)}%` 
                  }}></div>
                </div>
              </div>
            </div>
          </div>

          {/* My Library and Quick Links - side by side */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', marginBottom: '24px' }}>
            {/* My Library */}
            <div style={{ background: 'white', borderRadius: '8px', padding: '24px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
              <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#1d2934', marginBottom: '16px', borderBottom: '1px solid #e0e0e0', paddingBottom: '8px' }}>My Library</h2>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div 
                  onClick={() => setPage('saved-patents')} 
                  style={{ display: 'flex', justifyContent: 'space-between', cursor: 'pointer', padding: '8px', borderRadius: '4px', background: '#f5f7fa' }}
                >
                  <span style={{ color: '#1d2934' }}>Saved Patents</span>
                  <span style={{ color: '#5e778a' }}>
                    {user.saved_patents?.count || 0} / {user.saved_patents?.limit >= 9999 ? '∞' : user.saved_patents?.limit || 0}
                  </span>
                </div>
                <div 
                  onClick={() => setPage('search')} 
                  style={{ display: 'flex', justifyContent: 'space-between', cursor: 'pointer', padding: '8px', borderRadius: '4px', background: '#f5f7fa' }}
                >
                  <span style={{ color: '#1d2934' }}>Saved Searches</span>
                  <span style={{ color: '#5e778a' }}>
                    {user.saved_searches?.count || 0} / {user.saved_searches?.limit >= 9999 ? '∞' : user.saved_searches?.limit || 0}
                  </span>
                </div>
                <div 
                  onClick={() => setPage('saved-comparisons')} 
                  style={{ display: 'flex', justifyContent: 'space-between', cursor: 'pointer', padding: '8px', borderRadius: '4px', background: '#f5f7fa' }}
                >
                  <span style={{ color: '#1d2934' }}>Saved Comparisons</span>
                  <span style={{ color: '#5e778a' }}>{user.saved_comparisons || 0}</span>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div style={{ background: 'white', borderRadius: '8px', padding: '24px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
              <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#1d2934', marginBottom: '16px', borderBottom: '1px solid #e0e0e0', paddingBottom: '8px' }}>Quick Links</h2>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <button onClick={() => setPage('search')} style={{ textAlign: 'left', padding: '8px', background: 'none', border: 'none', cursor: 'pointer', color: '#2563eb', fontSize: '15px' }}>
                  Search Patents
                </button>
                <button onClick={() => setPage('search-applications')} style={{ textAlign: 'left', padding: '8px', background: 'none', border: 'none', cursor: 'pointer', color: '#2563eb', fontSize: '15px' }}>
                  Search Applications
                </button>
                <button onClick={() => setPage('company-intel')} style={{ textAlign: 'left', padding: '8px', background: 'none', border: 'none', cursor: 'pointer', color: '#2563eb', fontSize: '15px' }}>
                  Company Intelligence
                </button>
                {(user.tier === 'premium' || user.tier === 'pro') && (
                  <button onClick={() => setPage('citations')} style={{ textAlign: 'left', padding: '8px', background: 'none', border: 'none', cursor: 'pointer', color: '#2563eb', fontSize: '15px' }}>
                    Citation Analysis
                  </button>
                )}
                {user.tier === 'pro' && (
                  <button onClick={() => setPage('prior-art-searches')} style={{ textAlign: 'left', padding: '8px', background: 'none', border: 'none', cursor: 'pointer', color: '#2563eb', fontSize: '15px' }}>
                    Prior Art Searches
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Recent Activity */}
          <div style={{ background: 'white', borderRadius: '8px', padding: '24px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#1d2934', marginBottom: '16px', borderBottom: '1px solid #e0e0e0', paddingBottom: '8px' }}>Recent Activity</h2>
            {savedSearches.length === 0 ? (
              <p style={{ color: '#5e778a', fontSize: '14px' }}>No recent activity yet. Start by searching for patents!</p>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {savedSearches.slice(0, 5).map((search, index) => (
                  <div 
                    key={search.id || index}
                    onClick={() => handleSearch(null, search.query, 'local')}
                    style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center',
                      padding: '12px', 
                      background: '#f5f7fa', 
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    <div>
                      <div style={{ color: '#1d2934', fontWeight: '500' }}>Searched: "{search.query}"</div>
                      <div style={{ color: '#5e778a', fontSize: '13px', marginTop: '4px' }}>
                        {search.created_at ? new Date(search.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : 'Unknown date'}
                      </div>
                    </div>
                    <span style={{ color: '#2563eb', fontSize: '14px' }}>Run again</span>
                  </div>
                ))}
                {savedSearches.length > 5 && (
                  <button 
                    onClick={() => setPage('search')}
                    style={{ 
                      textAlign: 'center', 
                      padding: '8px', 
                      background: 'none', 
                      border: '1px solid #e0e0e0', 
                      borderRadius: '4px',
                      cursor: 'pointer', 
                      color: '#5e778a', 
                      fontSize: '14px',
                      marginTop: '8px'
                    }}
                  >
                    View all {savedSearches.length} saved searches
                  </button>
                )}
              </div>
            )}
          </div>

        </main>
      </div>
    );
}

export default DashboardPage;
